<template>
    <ul class="gap-2 grid grid-cols-2 p-4">
        <li
            v-for="item in nav"
            :key="item.href"
            :class="[item.class, item.subItems ? 'hover:bg-primary/5 border border-primary/15 rounded p-4' : '']"
        >
            <DrawerClose as-child>
                <NuxtLink
                    :to="item.href"
                    class="block p-4 rounded w-full"
                    :class="item.subItems ? '' : 'hover:bg-primary/5 border border-primary/15'"
                >
                    <div class="flex flex-col justify-center items-center gap-2 w-full">
                        <Icon v-if="item.icon" :name="item.icon" class="block size-8! text-primary" />
                        <Typography class="mt-2">{{ item.title }}</Typography>
                    </div>
                </NuxtLink>
            </DrawerClose>
            <div v-if="item.subItems">
                <Separator />
                <ul class="gap-4 grid grid-cols-2 mt-2 rounded">
                    <li v-for="subItem in item.subItems" :key="subItem.href" class="block hover:bg-primary/5 aspect-square">
                        <DrawerClose as-child>
                            <NuxtLink
                                :to="subItem.href"
                                class="group relative flex flex-col justify-center items-center gap-2 rounded w-full overflow-hidden aspect-square"
                            >
                                <Image :desktop="subItem.image" class="block text-primary w-full h-full" preset="thumbnail" />
                                <UiGlass
                                    tint="primary"
                                    class="bottom-2 group-hover:bottom-4 left-1/2 absolute w-3/4 h-1/4 transition-all -translate-x-1/2 duration-300 delay-75 flex items-center justify-center"
                                    padding="sm"
                                    blur="xs"
                                >
                                    <Typography variant="h5" tag="span" class="mx-auto text-center text-white font-black text-sm">
                                        {{ subItem.title }}
                                    </Typography>
                                </UiGlass>
                            </NuxtLink>
                        </DrawerClose>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
import { Separator } from "@/components/ui/separator";
import { DrawerClose } from "@/components/ui/drawer";

interface Props {
    nav: NavMenuItem[];
}

defineProps<Props>();
</script>
